import appleMailLogo from '@/assets/icons/apple-mail.png';

export const AppleMailIcon = ({ className }: { className?: string }) => (
  <img src={appleMailLogo} className={className} alt="" />
);
